
































import { Component, Vue } from "vue-property-decorator";

@Component
export default class NotificationsComponent extends Vue {
  tab: string = "notifications";
  closeMenu(): void {
    this.$emit("close");
  }
}
